module.exports = __webpack_public_path__ + "static/media/3d_model_display_video.222f8ee2.mp4";